/** RL-1296 / RL-1301: GET/POST /medicine-leaflets (medicine-leaflets.dto.ts). */
export const LEAFLET_FIELDS = [
  'howToTake',
  'sideEffects',
  'whenToCallClinic',
] as const;

export type LeafletField = (typeof LEAFLET_FIELDS)[number];
export type LeafletLanguage = 'en' | 'ms';
export const LEAFLET_LANGUAGES: LeafletLanguage[] = ['en', 'ms'];

/** Plain text, up to this many characters per field (API LEAFLET_TEXT_MAX). */
export const LEAFLET_TEXT_MAX = 1500;

export type LeafletText = Record<LeafletField, string>;

export interface LeafletContent {
  en: LeafletText;
  ms: LeafletText;
}

export type LeafletVersionStatus = 'draft' | 'approved' | 'retired';

export interface LeafletVersion {
  id: string;
  version: number;
  status: LeafletVersionStatus;
  content: LeafletContent;
  updatedAt: string;
  updatedBy: string;
  approvedAt: string | null;
  approvedBy: string | null;
}

export interface LeafletMedicine {
  medicineId: string;
  name: string;
  generic: string;
  /** Label QR address; null until a leaflet is approved or the API has no base URL. */
  qrUrl: string | null;
  approved: LeafletVersion | null;
  draft: LeafletVersion | null;
}

export type LeafletState = 'approved' | 'draft' | 'none';

export interface LeafletsQuery {
  search?: string;
  state?: LeafletState;
}

export const emptyLeafletContent = (): LeafletContent => ({
  en: { howToTake: '', sideEffects: '', whenToCallClinic: '' },
  ms: { howToTake: '', sideEffects: '', whenToCallClinic: '' },
});

/** Every field in both languages is filled in (what the API needs to approve). */
export function isLeafletComplete(content: LeafletContent): boolean {
  return LEAFLET_LANGUAGES.every((language) =>
    LEAFLET_FIELDS.every((field) => content[language][field].trim().length > 0),
  );
}
